// extracted by mini-css-extract-plugin
export default {"btn":"src-components-BlackGrayButton-css__btn--WyxsN","checked":"src-components-BlackGrayButton-css__checked--t9Nnx","disabled":"src-components-BlackGrayButton-css__disabled--PB3i4"};